import { defineComponent as _defineComponent } from 'vue'
import ModalView from './ModalView.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalView',
  props: ['comp'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const vDynamicEvents = {
      bind: function (el, binding, vnode) {
        const allEvents = binding.value;

        Object.keys(allEvents).forEach((event) => {
          vnode.componentInstance.$on(event, (eventData) => {
            vnode.context.proxyEvent(event, allEvents[event], eventData);
          });
        });
      },
      unbind: function (el, binding, vnode) {
        vnode.componentInstance.$off();
      },
    }



const __returned__ = { props, vDynamicEvents, ModalView }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})